import { Order, OrderRow } from 'gung-standard';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TyloOrderRowsService {
  constructor(protected http: HttpClient) {}

  getOrderRowsDeliveryPlanning(customerId: string): Observable<OrderRow[]> {
    const url = `json/order-rows-delivery-planning/${customerId}`;
    const headers = {
      // maxAge: nocache ? '-1' : '300'
    };
    return this.http.get<OrderRow[]>(url, { headers });
  }

  setOrderRowExtraFields(row) {
    const url = `json/order/${row.extra.orp.ordernr}/row/extra/orp`;
    return this.http.put<Order>(url, { ordberlevdat: row.extra.orp.ordberlevdat, ordradnr: row.extra.orp.ordradnr });
  }

  setOrderExtraFields(row) {
    const url = `json/order/${row.extra.orp.ordernr}/extra/oh`;
    return this.http.put<Order>(url, { ordberlevdat: row.extra.orp.ordberlevdat });
  }

  setOrderRowsExtraFields(onr, rows) {
    const url = `json/order/${onr}/rows/extra/orp`;
    return this.http.put<Order>(url, rows);
  }
}
